//5. Замеров выполнено, шт (кол-во ЦО, если дата замера находится в пределах выбранного периода)
import {isDateInRange} from "./isDateInRange";

export const isValidMeasurements = (order, selectedMonths: string[], selectedYears: string[]): boolean => {
    return order["measurement-date-fact"]
        && isDateInRange(order["measurement-date-fact"], selectedMonths, selectedYears)
        && !order["measurement-responsiples"]?.match(/(Заказчик)/g);
}